import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-footer',
    imports: [TranslateModule, RouterModule],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  copyrightYears: string;

  constructor() {
    const startYear = 2023;
    const currentYear = new Date().getFullYear();
    this.copyrightYears = startYear === currentYear ? `${startYear}` : `${startYear} - ${currentYear}`;
  }
} 